import axios from '@/lib/axios';
import { TrialLensOrderParams } from '../types';

const createTrialLens = (data: TrialLensOrderParams) => {
  return axios.post('/facility/orders/trial_lens', data);
}

export default createTrialLens;